import { heroHighlights } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[620px] h-[88vh] max-h-[900px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20painterly%20abstract%20illustration%20of%20an%20evening%20balcony%20with%20blooming%20deep%20red%20roses%20and%20softly%20glowing%20paper%20lanterns%2C%20rich%20burgundy%20crimson%20and%20amber%20tones%2C%20blurred%20bokeh%20lights%2C%20romantic%20artistic%20atmosphere%2C%20textured%20oil%20brush%20strokes%2C%20dramatic%20dark%20vignette%20suitable%20for%20white%20text%20overlay&width=1920&height=1080&seq=plxdz-hero-main&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/15 text-background-50 text-xs md:text-sm backdrop-blur">
            <i className="ri-compass-3-line"></i>
            衍生内容 · 同款整理 · 一页找齐
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-tight text-background-50">
            漂亮的小姨子
            <span className="block mt-2 text-xl md:text-3xl lg:text-4xl font-semibold text-accent-300">
              小说 · 漫画 · 同人 · 番外 · 第二季与续集
            </span>
          </h1>
          <p className="mt-5 text-sm md:text-lg leading-relaxed text-background-100 max-w-2xl">
            这里把《漂亮的小姨子》相关的衍生内容按类别整理到一起：从主线小说、漫画改编，到同人创作、番外篇章，再到第二季与续集的查找方向，都可以在这一页按同一方向继续查看。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#novel"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-book-open-line"></i>
              从小说专区开始
            </a>
            <a
              href="#similar"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors"
            >
              <i className="ri-compass-3-line"></i>
              直接找同款
            </a>
          </div>

          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {heroHighlights.map((item) => (
              <div
                key={item.label}
                className="rounded-lg border border-background-50/20 bg-black/25 backdrop-blur px-3 py-3 md:px-4"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500/90 text-secondary-950 text-base">
                  <i className={item.icon}></i>
                </div>
                <p className="mt-2 text-sm font-medium text-background-50 whitespace-nowrap">{item.label}</p>
                <p className="text-xs text-background-200 mt-0.5">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}